import { ChangeEvent, useEffect } from "react"
import { css } from "@emotion/css"
import Options from "components/inputs/Options"
import { useQuery } from "react-query"
import { fetchAvailableAgencies } from "api/agencies"
import { useAgencyId } from "hooks/useAgencyId"

export const SelectAgency = () => {
  const { agencyId, setAgencyId } = useAgencyId()
  const { data: availableAgencies } = useQuery(
    "available-agencies",
    fetchAvailableAgencies,
  )

  const agenciesMapped = availableAgencies?.length
    ? availableAgencies?.map((a) => ({
        label: a?.name || "",
        value: a?.id || "",
      }))
    : []

  const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = evt.target
    !!name && setAgencyId(value)
  }

  const storedAgencyId = localStorage.getItem("agencyId") || undefined

  useEffect(() => {
    if (storedAgencyId) {
      setAgencyId(storedAgencyId)
    } else {
      const defaultAgencyId = availableAgencies?.[0]?.id ?? ""
      setAgencyId(defaultAgencyId)
    }
  }, [storedAgencyId, availableAgencies, setAgencyId])

  return (
    <div className={styles.container}>
      <Options
        name="agencyId"
        value={agencyId}
        options={agenciesMapped || []}
        onChange={handleChange}
        className={styles.input}
      />
    </div>
  )
}

const styles = {
  container: css`
    margin-right: auto;
  `,
  input: css`
    min-width: 112px;
    .MuiOutlinedInput-input {
      padding: 8px 32px 8px 16px;
    }
  `,
}
